<template>
  <div id="login-div">

    <h1 class="page-title mt-5 bold-text">
      {{ $t('loginTitle') }}
    </h1>
    <h2 class="page-subtitle mt-3">
      {{ $t('registerSubtitle') }}
    </h2>

    <form ref="form" @submit.stop.prevent="handleSubmit">

      <b-row class="row mt-4">
        <div class="col-md-6 ">
          <b-form-group
              :invalid-feedback="form.lastname.invalidFeedback"
              :label="$t('user.Lastname')"
              :state="form.lastname.state"
              class="mb-4"
              label-for="lastname-input">
            <b-form-input
                id="lastname-input"
                v-model="form.lastname.value"
                :state="form.lastname.state"
                maxlength="250"
                required
                type="text">
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6 ">
          <b-form-group
              :invalid-feedback="form.firstname.invalidFeedback"
              :label="$t('user.Firstname')"
              :state="form.firstname.state"
              class="mb-4"
              label-for="firstname-input">
            <b-form-input
                id="firstname-input"
                v-model="form.firstname.value"
                :state="form.firstname.state"
                maxlength="250"
                required
                type="text">
            </b-form-input>
          </b-form-group>
        </div>
      </b-row>

      <b-form-group
          :invalid-feedback="form.username.invalidFeedback"
          :label="$t('user.Username')"
          :state="form.username.state"
          class="mb-4"
          label-for="username-input">
        <b-form-input
            id="username-input"
            v-model="form.username.value"
            :state="form.username.state"
            required
            type="email"
            v-on:change="removeInvalidFeedback('username')">
        </b-form-input>
      </b-form-group>

      <b-form-group
          :invalid-feedback="form.phoneNumber.invalidFeedback"
          :label="$t('user.PhoneNumber')"
          :state="form.phoneNumber.state"
          class="mb-4"
          label-for="phoneNumber-input">
        <b-form-input
            id="phoneNumber-input"
            v-model="form.phoneNumber.value"
            :state="form.phoneNumber.state"
            maxlength="250"
            required
            type="text"
            v-on:change="removeInvalidFeedback('phoneNumber')">
        </b-form-input>
      </b-form-group>

<!--      <b-form-group-->
<!--          :invalid-feedback="form.password.invalidFeedback"-->
<!--          :label="$t('user.Password')"-->
<!--          :state="form.password.state"-->
<!--          class="mb-4"-->
<!--          label-for="password-input"-->
<!--      >-->
<!--        <div class="d-flex align-items-center">-->
<!--          <b-form-input-->
<!--              id="password-input"-->
<!--              v-model="form.password.value"-->
<!--              :state="form.password.state"-->
<!--              :type="showPassword ? 'text' : 'password'"-->
<!--              autocomplete="off"-->
<!--              required-->
<!--          >-->
<!--          </b-form-input>-->
<!--          <b-input-group-append>-->
<!--            <b-button variant="light" @click="togglePassword">-->
<!--              <eye-icon v-if="!showPassword"></eye-icon>-->
<!--              <eye-off-icon v-else></eye-off-icon>-->
<!--            </b-button>-->
<!--          </b-input-group-append>-->
<!--        </div>-->
<!--      </b-form-group>-->

      <h2 class="page-subtitle mt-3">
        {{ $t('user.entreprise.infos') }}
      </h2>

      <b-row class="row mt-4">
        <div class="col-md-6 ">
          <b-form-group
              :invalid-feedback="form.entreprise.invalidFeedback"
              :label="$t('user.Entreprise')"
              :state="form.entreprise.state"
              class="mb-4"
              label-for="entreprise-input">
            <b-form-input
                id="entreprise-input"
                v-model="form.entreprise.value"
                :state="form.entreprise.state"
                maxlength="250"
                required
                type="text">
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6 ">
          <b-form-group
              :invalid-feedback="form.address.invalidFeedback"
              :label="$t('user.Address')"
              :state="form.address.state"
              class="mb-4"
              label-for="address-input">
            <b-form-input
                id="address-input"
                v-model="form.address.value"
                :state="form.address.state"
                maxlength="250"
                required
                type="text">
            </b-form-input>
          </b-form-group>
        </div>
      </b-row>

      <b-row class="row">
        <div class="col-md-6 ">
          <b-form-group
              :invalid-feedback="form.postalCode.invalidFeedback"
              :label="$t('user.PostalCode')"
              :state="form.postalCode.state"
              class="mb-4"
              label-for="postalCode-input">
            <b-form-input
                id="postalCode-input"
                v-model="form.postalCode.value"
                :state="form.postalCode.state"
                maxlength="250"
                required
                type="text">
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6 ">
          <b-form-group
              :invalid-feedback="form.city.invalidFeedback"
              :label="$t('user.City')"
              :state="form.city.state"
              class="mb-4"
              label-for="city-input">
            <b-form-input
                id="city-input"
                v-model="form.city.value"
                :state="form.city.state"
                maxlength="250"
                required
                type="text">
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-12 text-center mb-4">
          <span class="textCgu1">{{ $t('Register.cgu.1') }} </span> <a  href="https://www.aprilyos.com/wp-content/uploads/2023/09/CGU.pdf" target="_blank" class="textCgu2">{{
            $t('Register.cgu.2')
          }}</a>
        </div>
      </b-row>
    </form>
    <b-button v-if="!hideInscription" class="btn-block bold-text" type="submit" variant="secondary" @click="handleOk">
      {{ $t('Register') }}
    </b-button>
    <div class="mt-4 text-center">
      <span>{{ $t('Already.account') }}</span>
      <span id="register-link" class="page-title" v-on:click="backToLogin">{{ $t('Login.here') }}</span>
    </div>
  </div>
</template>

<script>

import api from '../../services/api'
import i18n from '../../i18n'

export default {

  name: 'Register',

  data: function () {
    return {
      showPassword: false,
      hideInscription: false,
      form: {
        firstname:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        lastname:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        username:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        phoneNumber:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        // password: {
        //   value: null,
        //   state: null,
        //   invalidFeedback: null
        // },
        entreprise: {
          value: null,
          state: null,
          invalidFeedback: null,
        },
        address: {
          value: null,
          state: null,
          invalidFeedback: null,
        },
        postalCode: {
          value: null,
          state: null,
          invalidFeedback: null,
        },
        city: {
          value: null,
          state: null,
          invalidFeedback: null,
        }
      }
    }
  },

  emits: ['showLoginView', 'showUserCreateSuccessful'],

  mounted() {
  },

  methods: {
    // togglePassword() {
    //   this.showPassword = !this.showPassword
    // },


    resetModal() {
      this.form.firstname.value = null
      this.form.firstname.state = null
      this.form.firstname.invalidFeedback = null
      this.form.lastname.value = null
      this.form.lastname.state = null
      this.form.lastname.invalidFeedback = null
      this.form.username.value = null
      this.form.username.state = null
      this.form.username.invalidFeedback = null
      this.form.phoneNumber.value = null
      this.form.phoneNumber.state = null
      this.form.phoneNumber.invalidFeedback = null
      // this.form.password.value = null
      // this.form.password.state = null
      // this.form.password.invalidFeedback = null
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      if (!this.isFormValid()) {
        return
      }

      let formData = new FormData()
      formData.append('firstname', this.form.firstname.value)
      formData.append('lastname', this.form.lastname.value)
      formData.append('username', this.form.username.value)
      formData.append('phoneNumber', this.form.phoneNumber.value)
      formData.append('entreprise', this.form.entreprise.value)
      formData.append('address', this.form.address.value)
      formData.append('postalCode', this.form.postalCode.value)
      formData.append('city', this.form.city.value)
      // formData.append('password', this.form.password.value)

      api({
        method: 'POST',
        url: `/register/register`,
        data: formData
      })
          .then(() => {
            this.successToast()
            this.hideInscription = true
          })
          .catch(error => {
            if (error.response.status === 403) {
              const invalidField = error.response.data.invalidField
              this.form[invalidField]['state'] = false
              this.form[invalidField]['invalidFeedback'] = i18n.t(error.response.data.message)
            }
          })
    },

    backToLogin() {
      this.$emit('showLoginView')
    },

    isFormValid() {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
        return false
      }
      // if (this.form.password.value == null || this.form.password.value.trim() === '') {
      //   this.form.password.state = false
      //   this.form.password.invalidFeedback = this.$i18n.t('MandatoryField')
      //   return false
      // } else if (this.form.password.value.trim().length < 8) {
      //   this.form.password.state = false
      //   this.form.password.invalidFeedback = this.$i18n.t('Password.minlenght.error')
      //   return false
      // }

      return true
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('Register.success'), {
        autoHideDelay: 10000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },


  }

}
</script>

<style scoped>


#register-link {
  font-size: var(--title-level-two-font-size);
  font-family: "Montserrat-Bold", "Arial", sans-serif;
  text-decoration: underline;
  cursor: pointer;
}

#register-link:hover {
  color: var(--secondary-text-color);
}

.input-group-append {
  padding: unset;
  border: unset;
  border-radius: 0 4px 4px 0;
}

.textCgu1 {
  font-size: 12px;
}

.textCgu2 {
  color: var(--main-color);
  text-transform: uppercase;
  text-decoration: underline;
  cursor: pointer;
  font-size: 12px;
}

.textCgu2:hover {
  color: var(--main-red);
}



</style>



// WEBPACK FOOTER //
// src/views/auth/Register.vue